import React from "react"
import styled from "styled-components"
import { isTablet, isMobile } from "react-device-detect"
import { up } from "styled-breakpoints"

import FullScreenPlayer from "../atomic/organisms/FullScreenPlayer"
import { ContainerContext } from "../global/container"
import Menu from "./menu"

export default class HorizontalScroller extends React.Component {

  settings = {
    moving: false,
    scrollDir: "",
    scrollPos: 0,
    scrollTop: 0,
    speed: 40,
    smooth: 12,
  }

  state = {
    video: null,
    branding: true
  }

  componentDidMount() {

    this.settings = {
      moving: false,
      scrollDir: "",
      scrollPos: 0,
      scrollTop: 0,
      speed: 40,
      smooth: 12,
    }

    if (!isTablet && !isMobile) {

      setTimeout(() => {
        this.scrollContainer = document.getElementById('horizontal-scroll')
        this.target = (document.documentElement || document.body.parentNode || document.body)
        this.settings.scrollPos = 0
        this.target.scrollLeft = 0

        window.addEventListener("wheel", this.scroll, { passive: false })
        window.addEventListener("DOMMouseScroll", this.scroll, { passive: false })

        let mousewheelevt = /Firefox/i.test(navigator.userAgent) ? "DOMMouseScroll" : "mousewheel"

      }, 200)

    }

    if (typeof window !== `undefined`){
      let params = new URLSearchParams(window.location.search)
      if(params.get('hide') === `true`){
        this.setState({ branding: false })
      }
    }
  }

  playVideo(url) {
    this.setState({ video: url })
  }

  scroll = e => {

    const _this = this
    e.preventDefault()

    if (this.settings.scrollPos > this.settings.scrollTop)
      this.settings.scrollDir = "down"
    else
      this.settings.scrollDir = "up"

    this.settings.scrollTop = this.settings.scrollPos <= 0 ? 0 : this.settings.scrollPos

    let delta
    let mormaliseDelta = e.wheelDelta

    if(/Firefox/i.test(navigator.userAgent)) mormaliseDelta = e.deltaY

    if (e.detail) {
      if (mormaliseDelta)
        delta = (mormaliseDelta / e.detail / 40) * (e.detail > 0 ? 1 : -1)
      else
        delta = -e.detail / 3
    } else {
      delta = mormaliseDelta / 120
    }

    // this.settings.scrollPos += -delta * this.settings.speed
    this.settings.scrollPos += (delta * -1) * this.settings.speed
    this.settings.scrollPos = Math.max(0, Math.min(this.settings.scrollPos, this.target.scrollWidth - this.target.clientWidth))

    if (!_this.settings.moving)
      _this.updateScrollPosition()
  }

  updateScrollPosition = () => {

    this.settings.moving = true

    const delta = (this.settings.scrollPos - (this.target.scrollLeft || 0)) / this.settings.smooth

    this.target.scrollLeft += delta

    if (Math.abs(delta) > 1) {
      window.requestAnimationFrame(this.updateScrollPosition)
    }
    else {
      this.settings.moving = false
      window.cancelAnimationFrame(this.updateScrollPosition)
    }
  }

  componentWillUnmount() {

    let mousewheelevt = null

    window.removeEventListener("wheel", this.scroll, { passive: false })
    window.removeEventListener("DOMMouseScroll", this.scroll, { passive: false })
    window.cancelAnimationFrame(this.updateScrollPosition)

    this.scrollContainer = null
    this.target = null
    this.settings.scrollPos = 0

    this.settings = {
      moving: false,
      scrollDir: "",
      scrollPos: 0,
      scrollTop: 0,
      speed: 40,
      smooth: 12,
    }

  }

  render() {
    return (
      <ContainerContext.Provider
        value={{
          navigateTo: id => this.onAnchor(id),
          changeTheme: color => {
            this.setState({ logoColor: color }, () => console.log(this.state.logoColor))
          },
          playVideo: url => this.playVideo(url),
        }}
      >
        {this.state.video && (
          <FullScreenPlayer
            url={this.state.video}
            onEnd={() => this.setState({ video: null })}
          />
        )}
        {this.state.branding && <Menu transition={this.props.transition} />}
        <Scroll id="horizontal-scroll">
          <Container>
            <Content>{this.props.children}</Content>
          </Container>
        </Scroll>
      </ContainerContext.Provider>
    )
  }
}

const Scroll = styled.div`

  ${up('md')}{
    display: flex;
    align-items: center;
    height: 100vh;
  }
`

const Container = styled.div`

  ${up('md')}{
    display: flex;
    height: 100vh;
  }
`

const Content = styled.div`
  
  ${up('md')}{
    display: flex;
    flex-direction:column;
    align-items: flex-end;
    height: 100vh;
    flex-direction:row;
  }
`
